export default {
  title: 'Nueva variante',
  fields: {
    product: {
      label: 'Producto',
    },
    name: {
      label: 'Nombre',
      placeholder: 'Grande',
    },
    price: {
      label: 'Precio adicional',
    },
  },
  buttons: {
    save: 'Guardar',
    close: 'Cerrar',
  },
  toasts: {
    variant_got_created: 'Variante creada',
    variant_got_updated: 'Variante actualizada',
  },
};
